module.exports = __webpack_public_path__ + "static/media/FM__ASIC__FSG_August_2024.c1038407.pdf";